import SearchableSelect from '../Form/SearchableSelect';

const companyLabel = (option) =>
  typeof option === 'object'
    ? option.value || option.companyName || String(option.id ?? '')
    : String(option);

const companyValue = (option) =>
  typeof option === 'object' ? option.id : option;

/**
 * Placement section for add/edit student forms.
 * Company supports picking an existing master OR typing a new name (created on submit).
 */
const PlacementFields = ({ formData, dispatch, companyOptions }) => {
  const handleCompanyChange = (e) => {
    dispatch({
      type: 'UPDATE_NESTED_FIELD',
      section: 'placement',
      field: 'companyName',
      value: e.target.value,
    });
  };

  return (
    <>
      <h3 className="font-semibold mt-4 mb-2">🏢 Placement Information</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <SearchableSelect
            name="companyName"
            value={formData.placement?.companyName || formData.placement?.companyId || ''}
            onChange={handleCompanyChange}
            className="w-full"
            placeholder="Select or type company name"
            options={Array.isArray(companyOptions) ? companyOptions : []}
            getOptionLabel={companyLabel}
            getOptionValue={companyValue}
            creatable
            createLabel={(q) => `Add company “${q}”`}
            aria-label="Company name"
          />
          <p className="text-xs mt-1 theme-text-secondary">
            Select from list or type a new company name (will be created on submit)
          </p>
        </div>

        <input
          type="text"
          name="position"
          placeholder="Job Position"
          value={formData.placement?.position || ''}
          onChange={(e) =>
            dispatch({
              type: 'UPDATE_NESTED_FIELD',
              section: 'placement',
              field: 'position',
              value: e.target.value
            })
          }
          className="w-full px-4 py-3 theme-input rounded-lg theme-focus"
          style={{ 
            backgroundColor: 'var(--color-surface)',
            border: '2px solid var(--color-border)',
            color: 'var(--color-text)'
          }}
        />
      </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <input
        type="number"
        name="package"
        placeholder="Package (LPA)"
        value={formData.placement?.package || ''}
        onChange={(e) =>
          dispatch({
            type: 'UPDATE_NESTED_FIELD',
            section: 'placement',
            field: 'package',
            value: e.target.value
          })
        }
        className="w-full px-4 py-3 theme-input rounded-lg theme-focus"
        style={{ 
          backgroundColor: 'var(--color-surface)',
          border: '2px solid var(--color-border)',
          color: 'var(--color-text)'
        }}
      />

      <input
        type="text"
        name="location"
        placeholder="Job Location"
        value={formData.placement?.location || ''}
        onChange={(e) =>
          dispatch({
            type: 'UPDATE_NESTED_FIELD',
            section: 'placement',
            field: 'location',
            value: e.target.value
          })
        }
        className="w-full px-4 py-3 theme-input rounded-lg theme-focus"
        style={{ 
          backgroundColor: 'var(--color-surface)',
          border: '2px solid var(--color-border)',
          color: 'var(--color-text)'
        }}
      />
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <input
        type="date"
        name="interviewDate"
        placeholder="Interview Date"
        value={formData.placement?.interviewDate || ''}
        onChange={(e) =>
          dispatch({
            type: 'UPDATE_NESTED_FIELD',
            section: 'placement',
            field: 'interviewDate',
            value: e.target.value
          })
        }
        className="w-full px-4 py-3 theme-input rounded-lg theme-focus"
        style={{ 
          backgroundColor: 'var(--color-surface)',
          border: '2px solid var(--color-border)',
          color: 'var(--color-text)'
        }}
      />

      <input
        type="date"
        name="placementDate"
        placeholder="Date of Placement"
        value={formData.placement?.placementDate || ''}
        onChange={(e) =>
          dispatch({
            type: 'UPDATE_NESTED_FIELD',
            section: 'placement',
            field: 'placementDate',
            value: e.target.value
          })
        }
        className="w-full px-4 py-3 theme-input rounded-lg theme-focus"
        style={{ 
          backgroundColor: 'var(--color-surface)',
          border: '2px solid var(--color-border)',
          color: 'var(--color-text)'
        }}
      />
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <input
        type="date"
        name="joiningDate"
        placeholder="Joining Date"
        value={formData.placement?.joiningDate || ''}
        onChange={(e) =>
          dispatch({
            type: 'UPDATE_NESTED_FIELD',
            section: 'placement',
            field: 'joiningDate',
            value: e.target.value
          })
        }
        className="w-full px-4 py-3 theme-input rounded-lg theme-focus"
        style={{ 
          backgroundColor: 'var(--color-surface)',
          border: '2px solid var(--color-border)',
          color: 'var(--color-text)'
        }}
      />
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
      <input
        type="text"
        name="result"
        placeholder="Interview Result"
        value={formData.placement?.result || ''}
        onChange={(e) =>
          dispatch({
            type: 'UPDATE_NESTED_FIELD',
            section: 'placement',
            field: 'result',
            value: e.target.value
          })
        }
        className="w-full px-4 py-3 theme-input rounded-lg theme-focus"
        style={{ 
          backgroundColor: 'var(--color-surface)',
          border: '2px solid var(--color-border)',
          color: 'var(--color-text)'
        }}
      />

      <input
        type="text"
        name="offerDetails"
        placeholder="Offer Details"
        value={formData.placement?.offerDetails || ''}
        onChange={(e) =>
          dispatch({
            type: 'UPDATE_NESTED_FIELD',
            section: 'placement',
            field: 'offerDetails',
            value: e.target.value
          })
        }
        className="w-full px-4 py-3 theme-input rounded-lg theme-focus"
        style={{ 
          backgroundColor: 'var(--color-surface)',
          border: '2px solid var(--color-border)',
          color: 'var(--color-text)'
        }}
      />
    </div>

    {/* Alumni/Student Group Management - Show when placement data exists */}
    {(formData.placement?.companyName || formData.placement?.position || formData.placement?.result) && (
      <div className="mt-4 pt-4 border-t">
        <h4 className="font-semibold mb-3 text-sm">👥 Group Management</h4>
        
        <div className="mb-4">
          <label className="block mb-2 font-medium text-sm" style={{ color: 'var(--color-text)' }}>
            Remove from placement group and move to Alumni group?
          </label>
          <div className="flex gap-4 mb-2">
            <label className="flex items-center">
              <input
                type="radio"
                name="shouldMoveToAlumni"
                value="Yes"
                checked={formData.placement?.shouldMoveToAlumni === 'Yes' || formData.placement?.shouldMoveToAlumni === true || formData.placement?.shouldMoveToAlumni === 'true' || formData.placement?.shouldMoveToAlumni === undefined || formData.placement?.shouldMoveToAlumni === ''}
                onChange={(e) => {
                  const value = e.target.value === 'Yes' ? 'Yes' : 'No';
                  dispatch({
                    type: 'UPDATE_NESTED_FIELD',
                    section: 'placement',
                    field: 'shouldMoveToAlumni',
                    value: value
                  });
                  // Clear removal reason if Yes is selected
                  if (value === 'Yes') {
                    dispatch({
                      type: 'UPDATE_NESTED_FIELD',
                      section: 'placement',
                      field: 'placementGroupRemovalReason',
                      value: ''
                    });
                  }
                }}
                className="mr-2"
              />
              <span style={{ color: 'var(--color-text)' }}>Yes</span>
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="shouldMoveToAlumni"
                value="No"
                checked={formData.placement?.shouldMoveToAlumni === 'No' || formData.placement?.shouldMoveToAlumni === false || formData.placement?.shouldMoveToAlumni === 'false'}
                onChange={(e) => {
                  const value = e.target.value === 'No' ? 'No' : 'Yes';
                  dispatch({
                    type: 'UPDATE_NESTED_FIELD',
                    section: 'placement',
                    field: 'shouldMoveToAlumni',
                    value: value
                  });
                }}
                className="mr-2"
              />
              <span style={{ color: 'var(--color-text)' }}>No</span>
            </label>
          </div>
          
          {/* Show reason input if No is selected */}
          {(formData.placement?.shouldMoveToAlumni === 'No' || formData.placement?.shouldMoveToAlumni === false || formData.placement?.shouldMoveToAlumni === 'false') && (
            <textarea
              name="placementGroupRemovalReason"
              placeholder="Why not? (Required)"
              value={formData.placement?.placementGroupRemovalReason || ''}
              onChange={(e) =>
                dispatch({
                  type: 'UPDATE_NESTED_FIELD',
                  section: 'placement',
                  field: 'placementGroupRemovalReason',
                  value: e.target.value
                })
              }
              className="w-full mb-2 px-4 py-2 border rounded theme-input"
              style={{ 
                backgroundColor: 'var(--color-surface)',
                border: '2px solid var(--color-border)',
                color: 'var(--color-text)'
              }}
              rows="3"
              required
            />
          )}
        </div>
      </div>
    )}
  </>
  );
};

export default PlacementFields;

